<template>
    <div class="grid items-center grid-cols-12 text-xs bg-white dark:bg-neutral-950">
        <div class="col-span-4 py-2 pl-2">
            <div v-if="order.event && order.event.title && order.event.title.name" class="truncate">
                {{ order.event.title.name }}
            </div>
            <div v-if="order.event.venue && order.event.venue.name">
                {{ order.event.venue.name }}
            </div>
        </div>
        <div v-if="order.event && order.event.datetime_from" class="col-span-1 truncate">
            {{ dateTimeHumanReadableWithoutYearFromISO(order.event.datetime_from) }}
        </div>
        <div class="col-span-1 truncate">
            {{ order.school }}
        </div>
        <div class="col-span-1 truncate">
            {{ order.contact }}
        </div>
        <div class="col-span-1 truncate">
            {{ order.phone }}
        </div>
        <div class="col-span-1 truncate">
            {{ order.email }}
        </div>
        <div class="col-span-1 truncate">
            {{ order.tax_id }}
        </div>
        <div class="col-span-1">
            {{ dateTimeHumanReadableWithoutYearFromISO(order.created_at) }}
        </div>
        <div class="flex justify-end col-span-1 pr-4">
            <Button :href="order.admin_url" target="_blank">
                <icon icon="hero/outline/eye" class="size-4"></icon>
            </Button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { EventOrder } from '@src/Events/Pages/types';
import { dateTimeHumanReadableWithoutYearFromISO } from '@src/Common/Helpers/dates';

interface Props {
    order?: EventOrder | null;
}

const props = withDefaults(defineProps<Props>(), {
    order: null,
});

const order = toRef(props, 'order');
</script>
